export type EVType = 'economy' | 'midsize' | 'truck';

export const EV_CHARGING_RATES: Record<EVType, number> = {
  economy: 7.2,
  midsize: 11.0,
  truck: 19.2,
};

export const EV_TYPE_LABELS: Record<EVType, string> = {
  economy: 'Economy (7.2 kW)',
  midsize: 'Mid-Size (11 kW)',
  truck: 'Truck/SUV (19.2 kW)',
};

export type HomeSize = 'small' | 'medium' | 'large' | 'custom';

export const HOME_BASE_LOADS: Record<Exclude<HomeSize, 'custom'>, number> = {
  small: 2.0,
  medium: 3.5,
  large: 5.0,
};

export const HOME_SIZE_LABELS: Record<HomeSize, string> = {
  small: 'Small (~2 kW)',
  medium: 'Medium (~3.5 kW)',
  large: 'Large (~5 kW)',
  custom: 'Custom',
};

export interface EVConfig {
  type: EVType;
}

export interface SystemPlanningConfig {
  evCount: 0 | 1 | 2 | 3;
  evConfigs: EVConfig[];
  homeSize: HomeSize;
  customHomeLoadKw: number;
  currentSolarKw: number;
  batteryStorageKwh: number;
}

export interface SystemRecommendations {
  totalLoadKw: number;
  currentRenewableCoveragePercent: number;
  recommendedSolarKw: number;
  additionalPanelsNeeded: number;
  recommendedBatteryKwh: number;
  additionalBatteryKwh: number;
  estimatedAnnualSavings: number;
  estimatedCo2ReductionLbs: number;
  simplePaybackYears: number | null;
  isAlreadyOptimal: boolean;
}

export const PANEL_WATT_RATING = 400;
export const SOLAR_COST_PER_WATT = 3.0;
export const BATTERY_COST_PER_KWH = 500;
export const GRID_PRICE_AVG_ANNUAL = 0.13;
export const CO2_LBS_PER_KWH = 0.85;
export const SOLAR_PEAK_HOURS_PER_DAY = 5;
export const TARGET_RENEWABLE_COVERAGE = 0.9;
export const WIND_BASELINE_KW = 2.8;
export const WIND_CAPACITY_FACTOR = 0.3;
